<template>
<div>
<p style="color: blue" class="font-weight-bolder">{{item.store}}  ---  {{item.title}} --- {{item.description}}  {{item.owner}} n.ro {{item.number}} del  {{item.data}} </p>

<!--      
<span  class="badge badge-pill badge-warning">{{data.documentId}}</span>
<span  class="badge badge-pill badge-light">{{data.movementId}}</span>
-->
</div>
</template>
<script>

export default {
  props  : ['item'],
  data () 
  {
    return {
      
    }
    
    },
 
   created () 
    {
      
     
     
    },
  methods: {
    
  }
}
</script>

<style p,span
 {
    font-family : 'Roboto Condensed';
    font-size   : 20px;
}
</style>
